import React from 'react';
import PayairWrapperSdk from "@payair/e-com-wrapper-sdk"

import { Table, TableHeader, TableRow, Segment, Header, Icon } from 'semantic-ui-react';

const formatBuildTimestamp = (timestamp: string | undefined): string => {
  if (!timestamp) return "Local server"

  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) return timestamp

  return date.toISOString().replace("T", " ").replace(/\.\d{3}Z$/, " UTC")
}

export default function VersionInfo() {

  const wrapperSdk = PayairWrapperSdk.ecomWrapperSdk
  const version = wrapperSdk.getVersion()
  const commitSha = process.env.REACT_APP_BUILD_COMMIT_SHA
  const commitShortSha = process.env.REACT_APP_BUILD_COMMIT_SHORT_SHA || commitSha?.slice(0, 8)
  const commitLabel = `${commitShortSha || "Local development"}${
    process.env.REACT_APP_BUILD_IS_DIRTY === "true" ? " (dirty)" : ""
  }`
  const commitUrl =
    commitSha && process.env.REACT_APP_BUILD_PROJECT_URL
      ? `${process.env.REACT_APP_BUILD_PROJECT_URL}/-/commit/${commitSha}`
      : undefined
  const pipelineId = process.env.REACT_APP_BUILD_PIPELINE_ID
  const pipelineUrl = process.env.REACT_APP_BUILD_PIPELINE_URL

  return (
    <div>
      <Header as="h5" attached="top">
        <Icon name="puzzle" />
        <Header.Content>Used components</Header.Content>
      </Header>
      <Segment size="mini" attached>
        <Table compact="very">
          <TableHeader>
            <TableRow>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Value</Table.HeaderCell>
            </TableRow>
          </TableHeader>
          <Table.Body>
            <Table.Row>
              <Table.Cell>DemoShop Commit</Table.Cell>
              <Table.Cell>
                {commitUrl ? (
                  <a href={commitUrl} target="_blank" rel="noreferrer">{commitLabel}</a>
                ) : commitLabel}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Branch</Table.Cell>
              <Table.Cell>{process.env.REACT_APP_BUILD_REF_NAME || "Local development"}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Pipeline</Table.Cell>
              <Table.Cell>
                {pipelineId && pipelineUrl ? (
                  <a href={pipelineUrl} target="_blank" rel="noreferrer">#{pipelineId}</a>
                ) : pipelineId ? `#${pipelineId}` : "Local build"}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Built At</Table.Cell>
              <Table.Cell>{formatBuildTimestamp(process.env.REACT_APP_BUILD_TIMESTAMP)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Wrapper Version</Table.Cell>
              <Table.Cell>{ version.version }</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Build Type</Table.Cell>
              <Table.Cell>{ version.buildType }</Table.Cell>
            </Table.Row>   
            {version.dependencies !== undefined &&
            <Table.Row>
              <Table.Cell>Dependencies</Table.Cell>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    { version.dependencies.map((dependency: any, index: number) => {
                    return <Table.Row key={index}>
                        <Table.Cell>{ dependency.sdk } ({ dependency.buildType })</Table.Cell>
                        <Table.Cell>{ dependency.version }</Table.Cell>
                      </Table.Row>                     
                    })}                    
                  </Table.Body>
                </Table>              
              </Table.Cell>
            </Table.Row>   
            }               
          </Table.Body>
        </Table>
      </Segment>
    </div>
  );
}
